import React, { Component } from "react";
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import "./styles.scss";
import PropertyDetailModal from './components/Search/PropertyDetailModal';
import Pagination from "./components/Parts/Pagination";
import Listing from "./components/Search/Listings/Listing";
import Database from './Helpers/Database.js';
import MyLoader from './components/Parts/Loader';
import VideoModal from "./components/Search/VideoModal";

const db = new Database;

const e = React.createElement;

class MyProperties extends Component {
    state = {
        allProperties: [],
        currentProperties: [],
        currentPage: 1,
        totalPages: null,
        selectedProperty: { id: null },
        selectedVideoProperty: {},
        user: {},
        pageUrl: window.location.href,
        loading: true,
        listingStatus: [],
        init: true
    };

    componentDidMount() {
// console.log('mounted')
        const TRACKING_ID = "G-JRDY0PZRZR";
        ReactGA.initialize(TRACKING_ID);

        let user = window.PAGE_PROPS
        let id = user.agent_website_account ? user.agent_website_account : user.id

        db.ajaxCall({
            action: 'agent_listings',
            page: 'public',
            id
        })
            .then(allProperties => {

                //let buyerRep = allProperties.filter((prop, i) => prop.listing_status === 'buyer_represented' || prop.listing_status === 'sold')
                //buyerRep.sort((a, b) => (parseInt(a.current_price) < parseInt(b.current_price)) ? 1 : -1)
                //allProperties = allProperties.filter((prop, i) => prop.listing_status !== 'sold')
                //allProperties = allProperties.filter((prop, i) => prop.listing_status !== 'buyer_represented')
                allProperties = allProperties.filter((prop, i) => prop.listing_status !== 'inactive')
                allProperties.sort((a, b) => (parseInt(a.current_price) < parseInt(b.current_price)) ? 1 : -1)
                //allProperties = [...allProperties, ...buyerRep]
                allProperties = [...allProperties]

                if (allProperties.length > 0) {
                    $('#listings-anchor').addClass('has-listings');
                    $('#listings-anchor-mobile').addClass('has-listings');
                }

                this.setState({ allProperties, loading: false });


            })

        db.fetchUser()
            .then(user => {
                this.setState({ user })
            })
    }

    componentDidUpdate(){
        window.onpopstate = e => {

          if (this.state.selectedProperty.id) {
            this.setState({ selectedProperty: {} })
          }
        }
      }

    refreshUser = () => {
        db.fetchUser()
            .then(user => {
                this.setState({ user })
            })
    }

    onPageChanged = data => {

        let { allProperties, init , totalPages } = this.state;
        const { currentPage , pageLimit } = data;

        allProperties = this.getFilteredProperties(allProperties);


        const offset = (currentPage - 1) * pageLimit;
        const currentProperties = allProperties.slice(offset, offset + pageLimit);
        totalPages = Math.ceil(allProperties.length / pageLimit);

        var target = $('#my-properties-react');

        if (!init) {
            $('html,body').animate({ scrollTop: target.offset().top - 90  }, 25);
        }

        init = false;

        this.setState({ currentPage, currentProperties, totalPages, init });

    };


    togglePropertyDetailsModal = (id = null) => {
        if (id === null) {
            this.setState({ selectedProperty: {id:null} })
        } else {
            if(Number.isInteger(id)){
                db.ajaxCall({
                  action: 'ajax_property_details',
                  id
                })
                  .then(property => {
                    let selectedProperty = property;
                    this.setState({ selectedProperty })

                    let url = new URL(selectedProperty.permalink);

                    history.pushState('', '', url.pathname);
                    ReactGA.send({ hitType: "pageview", page: url.pathname, title: selectedProperty.title });
                    let that = this;
                    if(!this.state.selectedProperty.brochure){
                      $.ajax({
                          url : '/wp-admin/admin-ajax.php',
                          data: {
                              action: 'get_property_brochure',
                              property: this.state.selectedProperty,
                          },
                          type : 'POST',
                          success: function (res) {
                            let newProperty = that.state.selectedProperty;
                            newProperty.brochure = res;
                            that.setState({ selectedProperty:newProperty })
                          }
                      });
                    }
                  })
            } else {
                this.setState({ selectedProperty: {} })
                history.pushState('', '', this.state.searchPageUrl);
                ReactGA.send({ hitType: "pageview", page: this.state.searchPageUrl });
              }
        }
    }

  toggleVideoModal = (id = null, video_raw = '', property_video = '') => {
    console.log(id, video_raw, property_video);
    if (id === null && (video_raw === '' || property_video === '')) {
      this.setState({ selectedVideoProperty: {} })
    }else{
      this.setState({ selectedVideoProperty: {id: id, video_raw: video_raw, property_video: property_video} })
    }
  }

  changeToMapView = (id) =>{
    window.location.href = '/land-for-sale/?search=&map=' + id;
  }

  handleChangeStatus = (e) => {
    const {value} = e.target;
    let {listingStatus} = this.state;
    const name = 'listingStatus'
    const all = listingStatus.indexOf('all')

    if (all > -1 && value !== 'all') {
      listingStatus.splice(all, 1);
    }

    const index = listingStatus.indexOf(value);
    if (index > -1) {
      listingStatus.splice(index, 1);
    } else {
      listingStatus = [...listingStatus, value];
    }

    if (value === 'all') {

      const all = listingStatus.indexOf('all')

      if (all > -1) { // exists
        $(`input[name=${name}]`).each((i, checkbox) => {

          const index = listingStatus.indexOf(checkbox.value);

          if (index === -1) {
            listingStatus = [...listingStatus, checkbox.value];
          }
        })
      } else {
        listingStatus = [];
      }
    }
    this.setState({
      listingStatus
    }, () => {
      this.onPageChanged({
        currentPage: 1,
        totalPages: this.state.totalPages,
        pageLimit: 30
      })
    });
  }

  getFilteredProperties = (properties) => {
    const {listingStatus} = this.state
    if (!listingStatus.length) {
      return properties;
    }
    return properties.filter(item => {
      const filterStatues = [...listingStatus];
      if (listingStatus.includes('for-sale') || listingStatus.includes('all')) {
        filterStatues.push('available', 'under_contract')
      }
      return filterStatues.includes(item.listing_status)
    })
  }

    render() {

        const {
            allProperties,
            currentProperties,
            listingStatus,
            selectedProperty,
            selectedVideoProperty,
            user,
            loading
        } = this.state;

        const totalProperties = this.getFilteredProperties(allProperties).length;

      return (
        <>
          <div className={`position-relative ${loading ? '' : 'd-none'}`}>
            <MyLoader absolute={true} loading={loading} message={"Loading Properties"} />
          </div>
          <div className={`container ${loading ? 'd-none' : ''}`} id="my-listings">
            <div className="row">
              <div className="col-12">
                <h2 className="text-center mt-5 mb-4">My Properties</h2>
                <div className="info d-flex flex-column">
                  <div className='d-flex w-100 justify-content-between align-items-center mb-3 z-index-2'>
                    <div className="total">
                      {totalProperties || 0} Properties:
                    </div>
                    <div className="select-container react">
                      <span className="current-selection">Status</span>
                      <ul name="status" className="status">
                        <div className="checkboxes">
                          <div className="checkbox-container full">
                            <input className="checkbox" onClick={this.handleChangeStatus} type="checkbox" id="all-status"
                                   name="listingStatus" value="all"
                                   checked={listingStatus.includes('all')} readOnly/>
                            <label htmlFor="all-status">Select All</label>
                          </div>

                          <div className="checkbox-container">
                            <input className="checkbox" onClick={this.handleChangeStatus} type="checkbox" id={'sold'}
                                   name="listingStatus" value={'sold'}
                                   checked={listingStatus.includes('sold')} readOnly/>
                            <label htmlFor={'sold'}>Sold</label>
                          </div>

                          <div className="checkbox-container">
                            <input className="checkbox" onClick={this.handleChangeStatus} type="checkbox" id={'for-sale'}
                                   name="listingStatus" value={'for-sale'}
                                   checked={listingStatus.includes('for-sale')} readOnly/>
                            <label htmlFor={'for-sale'}>For Sale</label>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {
                currentProperties.map((property, i) => (
                  <Listing
                    {...property}
                    key={i}
                    togglePropertyDetailsModal={this.togglePropertyDetailsModal}
                    toggleVideoModal={this.toggleVideoModal}
                    favorites={user.favorites}
                    refreshUser={this.refreshUser}
                    changeToMapView={this.changeToMapView}
                  />
                ))
              }
            </div>
            <div className="row">
              {
                totalProperties ? (
                  <Pagination
                    currentPage={this.state.currentPage}
                    totalRecords={totalProperties}
                    pageLimit={30}
                    pageNeighbours={1}
                    onPageChanged={this.onPageChanged}
                  />
                ) : ''
              }
            </div>
            <PropertyDetailModal
              {...selectedProperty}
              togglePropertyDetailsModal={this.togglePropertyDetailsModal}
              favorites={user.favorites}
              refreshUser={this.refreshUser}
            />
            {
              Object.keys(selectedVideoProperty).length > 0 &&
              <VideoModal
                toggleVideoModal={this.toggleVideoModal}
                id={selectedVideoProperty.id}
                video_raw={selectedVideoProperty.video_raw}
                property_video={selectedVideoProperty.property_video}
              />
            }
          </div>
        </>
      );
    }
}



const domContainer = document.querySelector('#my-properties-react');
if (domContainer) {
ReactDOM.render(<MyProperties />, domContainer);
}
